// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"ErrorMessage_errorWrapper__2_D5L","underlinedText":"ErrorMessage_underlinedText__33F_d"};